/**
 * 生成图片查看URL
 * @param imageId 图片ID
 * @returns 完整的图片查看URL
 */
export const getImageUrl = (imageId: string): string => {
  const baseUrl = process.env.REACT_APP_API_URL || 'http://admin.jieyudayaofang.com';
  // 移除baseUrl末尾的/api，然后重新添加
  const cleanBaseUrl = baseUrl.replace(/\/api$/, '');
  // 添加时间戳参数来避免缓存问题
  const timestamp = Date.now();
  return `${cleanBaseUrl}/api/images/${imageId}/view?t=${timestamp}`;
};

/**
 * 生成图片缩略图URL（如果需要的话）
 * @param imageId 图片ID
 * @param width 宽度
 * @param height 高度
 * @returns 缩略图URL
 */
export const getThumbnailUrl = (imageId: string, width: number = 300, height: number = 200): string => {
  const baseUrl = process.env.REACT_APP_API_URL || 'http://admin.jieyudayaofang.com';
  // 移除baseUrl末尾的/api，然后重新添加
  const cleanBaseUrl = baseUrl.replace(/\/api$/, '');
  // 添加时间戳参数来避免缓存问题
  const timestamp = Date.now();
  return `${cleanBaseUrl}/api/images/${imageId}/view?width=${width}&height=${height}&t=${timestamp}`;
}; 